import React, { useContext, useCallback } from 'react'
import { Box, Text, Button } from '@usap/uicomponents'
import { SelectedItemsContext } from '../../../../contexts/SelectedItemsContextProvider'
import { ReturnItemContext } from '../../../../contexts/ReturnItemContextProvider'
import { Heading3 } from '../../../common/heading'
import useStaticTexts from './hooks/staticText'
import OrderItem from './component/OrderItem'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'
import RMASuccessWMO from './RMASuccessWMO'
import { useSparkChatEnabled } from '@usap/carparts/src/shared/hooks'

const RMASuccess = ({
  isDesktop,
  handleDone,
  orderDetails,
  OpenChatHandler,
}) => {
  const returnItemContextData = useContext(ReturnItemContext)
  const { setOrderItem, setReturnQty } = returnItemContextData
  const initialState = { orderItem: {} }
  const selectedItemsContextData = useContext(SelectedItemsContext)
  const {
    orderItems,
    applicationData,
    successData,
    selectedImages,
    setOrderItems,
    setApplicationData,
    setSuccessData,
    setFilesUpload,
    setSelectedImages,
    filesUpload, 
  } = selectedItemsContextData

  const isWmoEnabled = useWmoEnabled()

  const isSparkChatEnabled = useSparkChatEnabled();

  const d = new Date(orderDetails.order_date)
  const options = {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  }
  const orderDate = d.toLocaleDateString('en-US', options)

  const intItemReturn = orderItems.length
  const staticTextToUse = orderItems[0].reasons[0].id === 'warrantyClaim' && intItemReturn === 1 ? 'warrantyClaim' : 'returns'

  const DoneButton = () => {
    setOrderItem(initialState)
    setReturnQty(0)
    setOrderItems([])
    setApplicationData(null)
    setSuccessData([])
    setSelectedImages({})
    setFilesUpload({})
    handleDone()
  }

  const staticTexts = useStaticTexts({
    applicationData,
    staticTextToUse,
    successData,
    orderDate,
  })

  const OpenChatBox = useCallback(e => {
    e.preventDefault();
    if(isSparkChatEnabled) {
      openSparkChatModal();
    } else {    
      OpenChatHandler();
    }
  }, [OpenChatHandler])

  if(isWmoEnabled) {
    return (
      <RMASuccessWMO  
        isDesktop={isDesktop}
        DoneButton={DoneButton}
        orderItems={orderItems}
        selectedImages={selectedImages}
        filesUpload={filesUpload}
        applicationData={applicationData}
        successData={successData}
        orderDate={orderDetails.order_date}
        type={staticTextToUse}
      />
    )
  }

  return (
    <>
      <Box>
        <Box direction="row" pad="small" align="center">
          <Box margin={{ right: '10px' }}>
            { staticTexts.icon }
          </Box>
          <Box>
            <Heading3 style={{ fontSize: '18px' }} title="Thank you!" />
            <Text size="small" weight={700}>
              { staticTexts.headingText }
            </Text>
          </Box>
        </Box>

        <Box>
          { staticTexts.description }
        </Box>
      </Box>
      <Box
        id="itemsTableConfimation"
        margin={{ top: '16px' }}
        style={{
          fontFamily: 'Roboto',
          border: '1px #CCCACA solid',
          borderRadius: '6px 6px 0 0',
          backgroundColor: '#FFF',
          width: '100%',
          height: '74px',
        }}
      >
        <Box style={{ margin: '16px' }}>
          { staticTexts.tableItemDescription }
        </Box>
      </Box>
      <OrderItem
        orderItems={orderItems}
        isDesktop={isDesktop}
        selectedImages={selectedImages}
        filesUpload={filesUpload}
      />
      <Box align="center" margin={{ top: '24px' }}>
        <Button
          key="DoneButton"
          custom
          id="Done Button"
          style={{
            fontFamily: 'Roboto',
            fontSize: 16,
            letterSpacing: 0,
            width: '226px',
            textAlign: 'center',
            marginBottom: '16px',
            fontWeight: 500,
            color: '#2E4787',
            border: '2px #2E4787 solid',
            borderRadius: '23px',
            background: '#FFF',
          }}
          fill="vertical"
          label="Done"
          primary
          onClick={() => DoneButton()}
          size="large"
        />
      </Box>
      <Box align="center">
        <Text size="small" margin={{ bottom: '20px' }}>
          Need help?
          {' '}
          <button
            type="button"
            onClick={OpenChatBox}
            href="#"
            rel="noreferrer"
            style={{
              color: '#05629B',
              cursor: 'pointer',
              background: 'none',
              border: 'none',
              padding: 0,
              fontSize: '14px',
            }}
          >
            Chat with us
          </button>
        </Text>
      </Box>
    </>
  )
}

export default RMASuccess
